import React from 'react';
import './WhatsAppConfirmModal.css';

const WhatsAppConfirmModal = ({ isOpen, onClose, onConfirm, itemCount }) => {
    if (!isOpen) return null;

    return (
        <div className="whatsapp-confirm-overlay" onClick={onClose}>
            <div className="whatsapp-confirm-modal" onClick={(e) => e.stopPropagation()}>
                <div className="whatsapp-confirm-icon">
                    💬
                </div>
                
                <h2 className="whatsapp-confirm-title">¡Pedido listo! 🎉</h2>
                <p className="whatsapp-confirm-message">
                    Tu pedido de {itemCount} {itemCount === 1 ? 'producto' : 'productos'} está preparado
                </p>
                
                <button className="whatsapp-confirm-button" onClick={onConfirm}>
                    Enviar por WhatsApp
                </button>
                
                <button className="whatsapp-cancel-button" onClick={onClose}>
                    Cancelar
                </button>
            </div>
        </div>
    );
};

export default WhatsAppConfirmModal;
